/**
 * Factory file for tags. Not much here, but let's share example and UT data
 *
 * @exports Tags
 * @category Factories
 */
export default {
  getTags: (initialData = []) => [
    {
      text: 'hello',
      closable: true,
    },
    {
      text: 'these',
    },
    {
      text: 'are',
      closable: true,
    },
    {
      text: 'tags',
    },
    ...initialData,
  ],
};
